// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2CsNQ","checkmark":"styles_checkmark__1b1GM"};